import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Sprout, Leaf } from "lucide-react";

export const DashboardBanners = ({ tree, onChange }) => {
  const [busy, setBusy] = useState(false);
  const graduation = tree.graduation;
  const harvestReady = tree.harvest_ready;
  const isVeggie = tree.plant_type === "Vegetable";

  const handleGraduation = async () => {
    setBusy(true);
    try {
      await api.put(`/trees/${tree.id}/pot-size`, { pot_size: graduation.next_stage });
      toast.success(`Stage updated to ${graduation.next_stage}`);
      onChange();
    } catch (e) {
      toast.error("Could not update stage");
    } finally { setBusy(false); }
  };

  const handleSuccession = async () => {
    const notes = window.prompt("Log this harvest — yield notes (optional):", "") ?? "";
    setBusy(true);
    try {
      await api.post(`/trees/${tree.id}/succession`, { yield_notes: notes });
      toast.success("Crop archived · bed reset to Seed (misting mode)");
      onChange();
    } catch (e) {
      toast.error("Could not run succession reset");
    } finally { setBusy(false); }
  };

  if (!graduation && !isVeggie) return null;

  return (
    <div className="mt-6 space-y-3">
      {graduation && (
        <div data-testid="graduation-banner" className="flex items-center justify-between gap-4 p-4 rounded-2xl border border-emerald-200 bg-emerald-50">
          <div className="flex items-center gap-3">
            <Sprout className="w-6 h-6 text-emerald-700 shrink-0" />
            <div>
              <p className="text-sm font-semibold text-emerald-950">{graduation.message}</p>
              <p className="text-xs text-emerald-700/70">Current size: {tree.pot_size} · Day {tree.days_since_planting}</p>
            </div>
          </div>
          <button data-testid="graduation-action" onClick={handleGraduation} disabled={busy}
            className="shrink-0 rounded-full px-4 py-2 text-xs font-bold uppercase tracking-wider bg-emerald-700 hover:bg-emerald-600 disabled:opacity-50 text-white transition-colors">
            {busy ? "Updating…" : `Advance to ${graduation.next_stage}`}
          </button>
        </div>
      )}

      {isVeggie && (
        <div data-testid="harvest-banner" className={`flex items-center justify-between gap-4 p-4 rounded-2xl border ${harvestReady ? "border-amber-300 bg-amber-50" : "border-stone-200 bg-white"}`}>
          <div className="flex items-center gap-3">
            <Leaf className={`w-6 h-6 shrink-0 ${harvestReady ? "text-amber-600" : "text-emerald-700"}`} />
            <div>
              <p className="text-sm font-semibold text-stone-900">
                {harvestReady ? `${tree.name} has reached its fallback maturity limit!` : `${tree.name} · active yield track`}
              </p>
              <p className="text-xs text-stone-500">Ready to clear the bed and reset your watering schedule?</p>
            </div>
          </div>
          <button data-testid="harvest-action" onClick={handleSuccession} disabled={busy}
            className="shrink-0 rounded-full px-4 py-2 text-xs font-bold uppercase tracking-wider bg-amber-600 hover:bg-amber-500 disabled:opacity-50 text-white transition-colors">
            {busy ? "Processing…" : "Log Harvest & Replant"}
          </button>
        </div>
      )}
    </div>
  );
};
